import axios from 'axios'
import 'slick-carousel'
import { createApp } from 'vue'

const CLASS_NAME_IMAGE_SLIDER = 'js-image-slider'

document.addEventListener('DOMContentLoaded', () => {
  const elementsImageSlider = document.getElementsByClassName(
    CLASS_NAME_IMAGE_SLIDER
  )
  if (!elementsImageSlider.length) return

  Array.from(elementsImageSlider).forEach(async (elementImageSlider) => {
    const mediaGids = JSON.parse(elementImageSlider.dataset.images || '[]')
    if (!mediaGids || !mediaGids.length) return

    const storefrontAccessToken =
      elementImageSlider.dataset.storefrontAccessToken || ''

    try {
      const { data } = await axios.post(
        '/api/2024-07/graphql.json',
        {
          query: `
          query getMediaImages($ids: [ID!]!) {
            nodes(ids: $ids) {
              ... on MediaImage {
                id
                image {
                  url
                  altText
                }
              }
            }
          }`,
          variables: {
            ids: mediaGids,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
          },
        }
      )

      createApp({
        name: 'SnippetsImageSlider',
        data() {
          return {
            mediaImages: data.data.nodes,
          }
        },
        mounted() {
          const elementContainer = elementImageSlider.querySelector(
            `.${CLASS_NAME_IMAGE_SLIDER}-container`
          )
          const elementPrev = elementImageSlider.querySelector(
            `.${CLASS_NAME_IMAGE_SLIDER}-prev`
          )
          const elementNext = elementImageSlider.querySelector(
            `.${CLASS_NAME_IMAGE_SLIDER}-next`
          )

          $(elementContainer).slick({
            centerMode: true,
            slidesToShow: 1,
            centerPadding: 0,
            dots: true,
            prevArrow: $(elementPrev),
            nextArrow: $(elementNext),
          })
        },
      }).mount(elementImageSlider)
    } catch (_) {
      elementImageSlider.closest('.t-product__section').remove()
    }
  })
})
